import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const SaleNewYear = () => {
  return (
    <>
    <Navbar/>
    
    <div>
      Sale New Year 2026
    </div>
    <Footer/>
    </>
  )
}

export default SaleNewYear
